import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import EventPage from "@/pages/EventPage";

function App() {
  const bgUrl = `${process.env.PUBLIC_URL || ""}/hero-havana-bg.png`;
  return (
    <div
      className="App min-h-screen"
      style={{
        backgroundImage: `linear-gradient(rgba(10, 32, 24, 0.48), rgba(10, 32, 24, 0.48)), url(${bgUrl})`,
        backgroundAttachment: "fixed, fixed",
        backgroundSize: "cover, cover",
        backgroundPosition: "center, center",
        backgroundRepeat: "no-repeat, no-repeat",
      }}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<EventPage />} />
          <Route path="*" element={<EventPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#123A2E",
            border: "1px solid rgba(212, 175, 55, 0.35)",
            color: "#F8F1DC",
            fontFamily: "'Plus Jakarta Sans', sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
